// frontend/src/utils/nettoyerHtml.js
// Affichage sécurisé du HTML des articles : à utiliser avant tout dangerouslySetInnerHTML.
//
// Le contenu d'un article est affiché dans le navigateur de ses lecteurs et de l'administrateur qui relit un brouillon.
// Sans nettoyage, un script glissé dans un article volerait la session (conservée dans le navigateur).
// On garde la mise en forme (styles en ligne, SVG de l'affiche de la Sainte-Cène) et on retire tout ce qui s'exécute.
import DOMPurify from 'dompurify';

const HOTES_VIDEO = ['www.youtube.com', 'www.youtube-nocookie.com', 'player.vimeo.com'];

const hoteDe = (url) => {
  try {
    return new URL(url || '', 'https://adresse-invalide.local').hostname;
  } catch (e) {
    return '';
  }
};

let initialise = false;
function initialiser() {
  if (initialise) return;
  initialise = true;

  DOMPurify.addHook('afterSanitizeAttributes', (noeud) => {
    // Vidéos intégrées : uniquement YouTube et Vimeo, dans un cadre isolé
    if (noeud.tagName === 'IFRAME') {
      const src = noeud.getAttribute('src') || '';
      if (!/^https:\/\//i.test(src) || !HOTES_VIDEO.includes(hoteDe(src))) {
        if (noeud.parentNode) noeud.parentNode.removeChild(noeud);
        return;
      }
      noeud.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation allow-popups');
      noeud.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    }
    // Liens sortants
    if (noeud.tagName === 'A') {
      noeud.setAttribute('rel', 'noopener noreferrer');
    }
    // Un style en ligne ne doit pas pouvoir recouvrir la page (faux écran de connexion par exemple)
    if (noeud.hasAttribute && noeud.hasAttribute('style')) {
      const style = noeud.getAttribute('style').replace(/(?:^|;)\s*(?:position|z-index)\s*:[^;]*/gi, '').replace(/^\s*;\s*/, '');
      noeud.setAttribute('style', style);
    }
  });
}

/** Renvoie le HTML nettoyé, prêt pour dangerouslySetInnerHTML ; null ou undefined donnent une chaîne vide. */
export function nettoyerHtml(html) {
  initialiser();
  if (html === null || html === undefined) return '';
  return DOMPurify.sanitize(String(html), {
    USE_PROFILES: { html: true, svg: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allowfullscreen', 'frameborder', 'target'],
    FORBID_TAGS: [
      'style', 'form', 'input', 'button', 'textarea', 'select', 'option', 'object', 'embed', 'link', 'meta', 'base',
      'use', 'foreignObject', 'animate', 'animateMotion', 'animateTransform', 'set',
    ],
    FORBID_ATTR: ['formaction'],
  });
}
